<div
    class="card mt-3 w-100"
    (click)="selected()"
    (mouseenter)="onHover.emit(parking)"
    (mouseleave)="onHover.emit(null)"
    [ngClass]="{ highlighted: highlighted }"
    appInViewport
    [threshold]="0.75"
    (visibilityChange)="onImpressionMade()"
>
    <ng-container *ngIf="parking">
        <ng-container *ngIf="parking.parkingType == ParkingType.BOOKING; else defaultTemplate">
            <app-parking-list-item-bookup [forMerchants]="forMerchants" [merchantKey]="merchantKey" [parking]="parking"></app-parking-list-item-bookup>
        </ng-container>

        <ng-template #defaultTemplate>
            <app-parking-list-item-classic [forMerchants]="forMerchants" [merchantKey]="merchantKey" [parking]="parking"></app-parking-list-item-classic>
        </ng-template>
    </ng-container>
</div>
